// Search / department / day / sort controls for the fill plan (Scott,
// 2026-07-02 voice: "filter by product or show things that need to be filled
// on a particular day; priority from top to bottom is important").

import type { BusinessDay, FillPlanFilterState, FillPlanSortKey } from './types';
import styles from './FillPlan.module.css';

const SORTS: { key: FillPlanSortKey; label: string }[] = [
  { key: 'priority', label: 'Priority' },
  { key: 'volume', label: 'Volume' },
  { key: 'due', label: 'Needed by' },
  { key: 'sku', label: 'A–Z' },
];

export function FillPlanControls({
  filters,
  onChange,
  departments,
  days,
  scoresLive,
}: {
  filters: FillPlanFilterState;
  onChange: (next: FillPlanFilterState) => void;
  departments: readonly string[];
  days: readonly BusinessDay[];
  scoresLive: boolean;
}) {
  return (
    <div className={styles.controls}>
      <input
        type="search"
        className={styles.search}
        placeholder="Search product, code, order…"
        value={filters.query}
        onChange={(e) => onChange({ ...filters, query: e.target.value })}
      />
      <select
        className={styles.select}
        value={filters.department}
        onChange={(e) => onChange({ ...filters, department: e.target.value })}
      >
        <option value="">All departments</option>
        {departments.map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </select>
      <select
        className={styles.select}
        value={String(filters.day)}
        onChange={(e) => onChange({ ...filters, day: Number(e.target.value) })}
      >
        <option value="0">All days</option>
        {days.map((d) => (
          <option key={d.n} value={String(d.n)}>
            Fills on Day {d.n} ({d.label})
          </option>
        ))}
      </select>
      <span className={styles.sortGroup}>
        {SORTS.map((s) => (
          <button
            key={s.key}
            type="button"
            className={filters.sort === s.key ? styles.sortOn : styles.sortBtn}
            title={
              s.key === 'priority'
                ? scoresLive
                  ? 'Order score (max across contributing orders), descending'
                  : 'Urgency proxy (late → due → critical PO → volume) — this run has flat order scores'
                : undefined
            }
            onClick={() => onChange({ ...filters, sort: s.key })}
          >
            {s.label}
            {s.key === 'priority' && !scoresLive && ' *'}
          </button>
        ))}
      </span>
    </div>
  );
}
